import { isMobile } from "react-device-detect";
import { useContext } from "react";
import { FacilitiesContext } from "../../providers/facility-provider/FacilitiesContext";
import { FacilityAddress } from "../../components/FacilityAddress";
import { EmailIcon, PhoneIcon } from "../../components/icons";
import { PageTitle, Subtitle2 } from "../../brand/typographies";
import { StorSelfIconButton } from "../../components/buttons/StorSelfIconButton";
import { Section } from "../../components/layout/Section";
import { companyConfig } from "../../globalContext";
import { Box } from "@mui/material";

export const ContactUsPage = () => {
    const { selectedFacility } = useContext(FacilitiesContext);
    return (
        <>
            <PageTitle>Contact Us</PageTitle>
            <FacilityAddress />
            <Section sx={{ my: 4, px: 4, boxSizing: "border-box", }}>
                {_context.companySettings.isSupportEmailEnabled &&
                    <StorSelfIconButton
                        fullWidth={!isMobile}
                        Icon={EmailIcon}
                        text="Email us"
                        href={`mailto: ${selectedFacility?.email || companyConfig.contactUsEmail}`} />}
                {
                    _context.companySettings.isSupportPhoneNumberEnabled &&
                    <CallUsButton phoneNumber={selectedFacility?.phone} />
                }
            </Section>
        </>
    );
};

const CallUsButton = ({ phoneNumber }: { phoneNumber?: string }) => {
    const number = phoneNumber || companyConfig.supportPhoneNumberFallback;

    if (!isMobile) {
        return (
            <Box display="flex" flexDirection={"column"} alignItems="center">
                <Subtitle2 bold>Call us:</Subtitle2>
                <Subtitle2>{number}</Subtitle2>
            </Box>
        )
    }

    return (
        <StorSelfIconButton
            Icon={PhoneIcon}
            text="Call us"
            href={`tel:${number}`
            } />
    )
}
